<template>
  <div id="app">
    <Header v-bind:id="idHeader" />
    <ModalLoading></ModalLoading>

    <div class="mt-3" v-if="loadCard == true">
      <Card :dn="lastNow" :text="textForecast" :anchorF="idForecast" :anchorA="idArchive" />
    </div>
    <div class="mt-3" v-if="loadNow == true">
      <InformationNow :dn="dataNow" :calm="calmProcent" v-bind:id="idArchive" />
    </div>
    <div class="mt-3" v-if="loadForecast == true">
      <InformationForecast :df="dataForecast" v-bind:id="idForecast" />
    </div>
    <div class="fixed-bottom m-1 text-right">
      <transition name="fade"> <img src="./assets/arrow-back.svg" class="arrow-back" :href="`#${idHeader}`"
          @click="goToBlock" v-if="scrolled" /></transition>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Card from "./components/Card.vue";
import InformationNow from "./components/InformationNow.vue";
import InformationForecast from "./components/InformationForecast.vue";
import ModalLoading from "./components/ModalLoading.vue";
import { GetLastItems } from "./scripts/getItems";
import CalculateСalmProcent from "./scripts/calm";
import { informationServiceNow, informationServiceLast, informationServiceWindDirection, informationServiceWindSpeed } from "./services/information";
import { forecastService, forecastWindDirectionService, forecastTextService } from "./services/forecast";
import getDatesBetween from "./scripts/beetwen";

export default {
  name: "App",
  data() {
    return {
      dataNow: "",
      dataForecast: "",
      loadNow: false,
      loadForecast: false,
      lastNow: "",
      lastForecast: "",
      textForecast: "",
      loadCard: false,
      calmProcent: "",
      idForecast: "forecast",
      idArchive: "archive",
      idHeader: "header",
      scrolled: false,
    };
  },
  async mounted() {
    /* Получение текстового прогноза */
    forecastTextService.get().then((e) => {
      this.textForecast = e;
    });
    /* Получение данных за трое суток */

    informationServiceNow.get().then((e) => {
      informationServiceWindDirection.get().then((w) => {

        const date = new Date();
        const dateBeginArchive = new Date();

        dateBeginArchive.setDate(dateBeginArchive.getDate() - 3);

        const beetwen = getDatesBetween(dateBeginArchive, date)
        const windTime = w[5].time.map(x => x.split(' ')[0])

        let difference = beetwen.filter(x => !windTime.includes(x));


        function sortByTime(data) {

          const indices = Array.from(data.time.keys());


          indices.sort((a, b) => new Date(data.time[a]) - new Date(data.time[b]));


          const sortedData = {
            time: indices.map(i => data.time[i]),
            values: indices.map(i => data.values[i])
          };

          return sortedData;
        }


        if (difference.length != 0) {

          difference.forEach(e => {
            w[5].time.push(`${e} 00:00:00`)
            w[5].values.push([])
          })

        }

        const sorted = sortByTime(w[5])
        sorted.type = "winddirect"
        sorted.name = 'Преобладающее направление ветра'


        e[5] = { ...sorted }

        console.log(w[5])

        this.dataNow = e;
        this.loadNow = true;

        /* Получение данных за сутки для карточки */
        informationServiceLast.get().then((e) => {
          GetLastItems(e).then(async (i) => {
            let un = false;

            for (let j in i) {
              if (i[j] === undefined) {
                un = true;
                break;
              }
            }

            if (un) {
              i = await GetLastItems(this.dataNow);
            }

            this.lastNow = i;
            this.loadCard = true;
          });
        });
      });

      informationServiceWindSpeed.get().then((w) => {

        this.calmProcent = CalculateСalmProcent(w[3].values.byday);

      });
    });
    /* получение прогноза на трое суток */
    forecastService.get().then((e) => {
      forecastWindDirectionService.get().then((w) => {
        e[5] = w[5];
        this.dataForecast = e;
        this.loadForecast = true;
      });
    });
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 460;
    },
    goToBlock: function (event) {
      event.preventDefault();
      let link = event.target.getAttribute("href");
      document.querySelector(link).scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
  components: {
    Header,
    Card,
    InformationNow,
    InformationForecast,
    ModalLoading,
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.arrow-back {
  padding: 10px;
  background-color: #c0c0c0;
  border-radius: 25px;
}

.arrow-back:hover {
  cursor: pointer;
}

* {
  font-family: "Times New Roman", Times, serif;
  font-size: 18px;
}

li {
  list-style-type: none;
}

ul {
  height: 100%;
}

.forecast-left {
  border-left: grey solid 1px;
}

.forecast-top {
  padding-top: 10px;
  border-top: grey solid 1px;
}

.arrow {
  position: absolute;
  width: 80px;
  height: 80px;
}

.vl {
  border-left: 2px solid #575757;
  width: 0px;
  border: 1px inset;
}

.bold {
  font-weight: bold;
}

.color-of-institute {
  color: #4472c4;
}

.temperature {
  background-color: #dae3f3;
  border: 2px solid white;
  font-size: 22px;
  color: #4472c4;
}

.header {
  font-family: Arial, Helvetica, sans-serif;
}

.text {
  font-size: 18px;
}

.italic {
  font-style: italic;
}

.attribute {
  margin-top: 10px;
}

.parameter {
  width: 140px !important;
}

.wind-img {
  width: 100px;
  height: 100px;
}

.info-card {
  background-color: #f2f2f2;
  border-radius: 20px;
  border: grey solid 1px;
}

.forecast {
  border-left: grey solid 1px;
}

.style-of-institute {
  color: #4472c4;
  border-top: 3px solid #4472c4;
}

@media (max-width: 1000px) {
  .forecast {
    padding-top: 10px;
    border-top: grey solid 1px;
    border-left: grey solid 0px;
  }
}

.displayCard {
  visibility: visible;
}

@media (max-width: 800px) {
  .displayCard {
    visibility: hidden;
    display: none;
  }
}
</style>
